import { render, staticRenderFns } from "./BusinessProfile.vue?vue&type=template&id=20bebaad&"
import script from "./BusinessProfile.vue?vue&type=script&lang=js&"
export * from "./BusinessProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports